import { render, staticRenderFns } from "./ScrollCarousel.vue?vue&type=template&id=0d492a07&scoped=true"
import script from "./ScrollCarousel.vue?vue&type=script&lang=js"
export * from "./ScrollCarousel.vue?vue&type=script&lang=js"
import style0 from "./ScrollCarousel.vue?vue&type=style&index=0&id=0d492a07&prod&lang=scss&scoped=true"
import style1 from "./ScrollCarousel.vue?vue&type=style&index=1&id=0d492a07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d492a07",
  null
  
)

export default component.exports